import React, { useState, useRef } from 'react';
import TooltipMUI from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import { ClickAwayListener } from '@mui/material';

const Tooltip = (props) => {
	const [open, setOpen] = useState(false);
	const wrapperRef = useRef(null);

	const handleMouseEnter = () => {
		setOpen(true);
	};

	const handleMouseLeave = () => {
		setOpen(false);
	};

	const handleClickAway = (event) => {
		if (wrapperRef?.current && !wrapperRef?.current?.contains(event?.target)) {
			setOpen(false);
		}
	};

	const handleClick = () => {
		setOpen(false);
	};

	const directionMap = {
		down: 'bottom',
		up: 'top',
		left: 'left',
		right: 'right',
	};

	const placement = directionMap[props?.direction] || 'bottom';

	return (
		<ClickAwayListener onClickAway={handleClickAway}>
			<div
				ref={wrapperRef}
				style={{
					...(props.inline && { display: 'inline-block' }),
				}}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				onClick={handleClick} // Hide tooltip when element clicked
			>
				<TooltipMUI
					open={open}
					disableFocusListener
					disableHoverListener
					disableTouchListener
					// followCursor
					enterDelay={1000}
					// leaveDelay={200}
					title={props?.content}
					placement={placement}
					PopperProps={{
						sx: {
							pointerEvents: 'none',
						},
						modifiers: [
							// {
							// 	name: 'flip',
							// 	options: {
							// 		fallbackPlacements: [
							// 			'top',
							// 			'right',
							// 			'left',
							// 		],
							// 	},
							// },
							{
								name: 'preventOverflow',
								options: {
									boundary: 'clippingParents', // or a custom element
									padding: 8,
								},
							},
							{
								name: 'offset',
								options: {
									offset: [
										typeof props.offsetX === 'number'
											? props.offsetX
											: 0,
										typeof props.offset === 'number'
											? props.offset
											: -10,
									],
								},
							},
						],
					}}
					componentsProps={{
						tooltip: {
							sx: {
								padding: '4px 8px',
								borderRadius: '4px',
								boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.16)',
								border: 'solid 1px #dedede',
								backgroundColor: '#fff',
								color: '#000',
								fontFamily: 'Inter-Regular',
								fontSize: '12px',
								fontWeight: 'normal',
								maxWidth: props?.style?.width ?? '280px',
							},
						},
					}}
				>
					<div style={{ all: 'inherit', ...(props.inline ? { display: 'inline-block' } : {}), }}>{props?.children}</div>
				</TooltipMUI>
			</div>
		</ClickAwayListener>
	);
};

Tooltip.defaultProps = {
	direction: 'bottom',
	offset: -10,
	offsetX: 0,
	width: '280px',
	inline: false,
};

Tooltip.propTypes = {
	children: PropTypes.node.isRequired,
	content: PropTypes.string.isRequired,
	style: PropTypes.object,
	direction: PropTypes.string,
	offset: PropTypes.number,
	width: PropTypes.string,
	offsetX: PropTypes.number,
	inline: PropTypes.bool,
};

export default Tooltip;
